import { render, staticRenderFns } from "./ConfirmationResetPinDialogComponent.vue?vue&type=template&id=9ed79c00&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports